import { Link } from 'react-router-dom';

export function NaveSettingsTabs({
  naveId,
  active,
}: {
  naveId: number;
  active: 'datos' | 'sensores';
}) {
  return (
    <nav aria-label="Ajustes de nave" className="grid grid-cols-2 border-b border-border">
      {(
        [
          { id: 'datos', label: 'Datos', to: `/ajustes/naves/${naveId}` },
          { id: 'sensores', label: 'Sensores', to: `/ajustes/naves/${naveId}/sensores` },
        ] as const
      ).map(({ id, label, to }) => (
        <Link
          key={id}
          to={to}
          aria-current={active === id ? 'page' : undefined}
          className={`flex min-h-12 items-center justify-center border-b-[3px] text-sm active:bg-ok-bg ${active === id ? 'border-ok-text font-semibold text-ok-text' : 'border-transparent text-text-secondary'}`}
        >
          {label}
        </Link>
      ))}
    </nav>
  );
}
